import React, { forwardRef } from "react";
const SvgAdd = (props, ref) => /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 12h16m-8-8v16", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgAdd);
export default ForwardRef;
